import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftRepository from "../../repositories/ShiftRepository";
import ShiftEntity from "../../entities/ShiftEntity";

interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class UpdateShiftUseCase {
    private shiftRepository: ShiftRepository;
    
    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }
    
    public call = async (shift: ShiftEntity) : Promise<Either<ErrorEntity, ShiftEntity>> => {
        return this.shiftRepository.updateShift(shift);
    }
}

export const UpdateShiftUseCaseName = "UpdateShiftUseCase";